<template>
    <v-select
        dense
        outlined
        hide-details
        background-color="white"
        clearable
        :items="items"
        :placeholder="$t('kommerziell')"
        v-bind="$attrs"
        v-on="$listeners"
    >
    </v-select>
</template>

<script>
export default {
    name: 'BannerCommercialSelect',
    created() {
        this.items = [
            {
                value: 'true',
                text: `${this.$t('kommerziell')}: ${this.$t('yes')}`,
            },
            {
                value: 'false',
                text: `${this.$t('kommerziell')}: ${this.$t('no')}`,
            },
        ];
    },
};
</script>
